import { EQueryUsageReportType } from '../e-query-usage-report-type';
import {FilterFieldValue} from '../../../../covance-filter';

export class AdminUsageEQueriesReportFilter {
    constructor(
        public key: string,
        public eQueryUsageReportType: EQueryUsageReportType,
        public filter: FilterFieldValue[]) {
    }
}
